module.exports = __webpack_public_path__ + "media/images/icons/envelop-0414ae37300390bf66b8a287a2f76a6e.svg";